var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66663 15.166C2.66663 12.2205 5.05444 9.83268 7.99996 9.83268C10.9455 9.83268 13.3333 12.2205 13.3333 15.166H12C12 12.9569 10.2091 11.166 7.99996 11.166C5.79082 11.166 3.99996 12.9569 3.99996 15.166H2.66663ZM7.99996 9.16602C5.78996 9.16602 3.99996 7.37602 3.99996 5.16602C3.99996 2.95602 5.78996 1.16602 7.99996 1.16602C10.21 1.16602 12 2.95602 12 5.16602C12 7.37602 10.21 9.16602 7.99996 9.16602ZM7.99996 7.83268C9.47329 7.83268 10.6666 6.63935 10.6666 5.16602C10.6666 3.69268 9.47329 2.49935 7.99996 2.49935C6.52663 2.49935 5.33329 3.69268 5.33329 5.16602C5.33329 6.63935 6.52663 7.83268 7.99996 7.83268Z",
    fill: "#5B4848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.fd32d083c972c76a2e6d32d331e344c1.svg";
export { ForwardRef as ReactComponent };